import {Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AlgebraKiTService } from "src/app/modules/algebrakit/services/algebrakit.service";
import { AuthoredExercise } from "src/app/modules/algebrakit/types/algebrakit.types";
import { AkitInteractionEditorComponent } from "src/app/modules/algebrakit/components/akit-interaction-editor/akit-interaction-editor.component";
import {Location} from '@angular/common'; 

@Component({
    templateUrl: "./editor.container.html",
    styleUrls: ["./editor.container.less"],
    selector: "app-editor",
    standalone: false
})
export class EditorContainer implements OnInit {
    public exerciseSpec: AuthoredExercise;
    public initialised: boolean = false;
    public refId: string;
    
    @ViewChild(AkitInteractionEditorComponent) editor:AkitInteractionEditorComponent;
    
    constructor(
        private akitService: AlgebraKiTService,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location
    ) {}

    async ngOnInit() {
        let exerciseId = this.route.snapshot.paramMap.get("id");
        if(!exerciseId) exerciseId = this.akitService.getCurrentExerciseId();
        if(exerciseId) {
            this.akitService.getExerciseFromId(exerciseId).then((spec: AuthoredExercise) => {
                this.exerciseSpec = spec;
                this.initialised = true;
            });
        } else {
            this.akitService.createEmptyExercise().then(_spec => {
                this.exerciseSpec = _spec;
                this.initialised = true;
            })
        }
    }
    
    isInteraction() {
        if(this.exerciseSpec && this.exerciseSpec.definition) {
            let def = this.exerciseSpec.definition;
            if(def.elements.length!=1) return false;
            let elm = def.elements[0];
            if(elm.interactions.length>1) return false;
            let interaction = elm.interactions[0];

            // move the element content into the interaction so that we can
            // keep using the interaction editor
            if(elm.content && interaction && !interaction.instruction) {
                interaction.instruction = elm.content;
                elm.content = null;
            }

        }
        return true;
    }
}
